/** Convierte un nombre o texto a slug URL-safe.
 *  "Sebastián Baudean" → "sebastian-baudean"
 *  "WTC UY"           → "wtc-uy"
 */
export function slugify(text: string): string {
	return text
		.toLowerCase()
		.normalize('NFD')
		.replace(/[\u0300-\u036f]/g, '') // elimina tildes/diacríticos
		.replace(/[^a-z0-9]+/g, '-')
		.replace(/^-+|-+$/g, '');
}

/** Lista canónica de equipos de ventas. */
export const SALES_TEAMS = ['WTC UY', 'PY', 'CENTRO UY', 'BO', 'CO'] as const;
export type SalesTeam = (typeof SALES_TEAMS)[number];

/** Resuelve un teamSlug a su nombre canónico buscando en SALES_TEAMS.
 *  "wtc-uy" → "WTC UY"   |   slug desconocido → undefined
 */
export function teamFromSlug(slug: string): string | undefined {
	return SALES_TEAMS.find((t) => slugify(t) === slug);
}

/** True si el team es uno de los equipos de ventas conocidos.
 *  Se usa en los guards de routing para no redirigir a rutas de equipo
 *  inválidas (ej. "DIRECCION"), lo que provocaría un loop de redirect.
 */
export function isSalesTeam(team: string | null | undefined): team is SalesTeam {
	return !!team && (SALES_TEAMS as readonly string[]).includes(team);
}
